import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { NConfigProvider, NMessageProvider, NLoadingBarProvider, NDialogProvider, NNotificationProvider } from 'naive-ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_unref(NConfigProvider), null, {
                default: _withCtx(() => [
                    _createVNode(_unref(NMessageProvider), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(NLoadingBarProvider), null, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(NDialogProvider), null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(NNotificationProvider), null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_router_view)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
